import React from "react";
import BlockContent from "./../BlockContent";
import { GatsbyImage } from "gatsby-plugin-image";

const ImageBlock = ({ description, title, notes, image }) => {
  return (
    <div>
      {description ? <p className="description">{description}</p> : null}
      <GatsbyImage image={image} alt={title} />
      {notes ? (
        <React.Fragment>
          <h2>Notes</h2>
          <BlockContent blocks={notes} />
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default ImageBlock;
